export enum AccountTypeAuth {
  LOCAL = "LOCAL",
  AD = "AD"
}
